import React, { Component } from 'react';
//import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
  WithStyles,
  createStyles,
  Button,
  Grid,
  Typography,
  Modal,
  Theme,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  LinearProgress,
} from '@material-ui/core';
//import { MyPATCollapse } from '../../common';
import PublishSharpIcon from '@material-ui/icons/PublishSharp';
import { connect } from 'react-redux';
import { showVideoModal } from '../mylibrary/actions/showVideoProgressActions';
//import { showVideoModal } from './../../../actions/showVideoProgressActions';
import axios from '../../services/axios';
//import CustomInfoIcon from '../../common/CustomInfoIcon';

const styles = (theme: Theme) =>
  createStyles({
    dashedBorder: {
      border: 'dashed 1px #000',
      padding: 8,
      borderRadius: 4,
    },

    dashedBlock: {
      width: 600,
      margin: 20,
      height: 240,
    },

    fontSize2X: {
      fontSize: 15,
    },
    lineHeight2X: {
      lineHeight: 20,
    },

    typographyStyle: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '15px',
      lineHeight: '20px',
      width: '100%',
    },

    modal: {
      display: 'flex',
      padding: 12,
      alignItems: 'center',
      justifyContent: 'center',
    },

    modalHeader: {
      height: 60,
      borderBottom: 'solid 1px #0004',
    },

    subHeadingFont: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 'bold',
    },

    margin1X: {
      margin: '6px',
    },
    buttonRoundBorder: {
      borderRadius: 0,
    },
    cardContent: {
      overflow: 'hidden',
    },
    dragDropVideoContainer: {
      border: 'dashed 1px #999',
      padding: '15px',
      textAlign: 'center',
      borderRadius: '5px',
      width: '170px',
    },
    dragDropVideoText: {
      color: '#a9a9a9',
      fontSize: '14px',
      fontWeight: 'normal',
      width: '140px',
      lineHeight: '18.2px',
      display: 'inline-block',
    },
  });

interface MathPixDataInterface {
  confidence: number;
  confidenceRate: number;
  text: string;
  html: string;
}

//@ts-ignore
interface MyPATFileUploadProps extends WithStyles<typeof styles> {
  classes: any;
  showVideoModal: Function;
  handleVideoSelect: Function;
  videoUploadHandler: Function;
}
interface MyPATFileUploadState {
  isUpload: boolean;
  uploadImage: string;
  isOpenUploadDialog: boolean;
  completed: number;
  zoomIcon: boolean;
  mathPixData: null | MathPixDataInterface;
  image: any;
  showZoomIcon: boolean;
  isCopied: boolean;
}

class MyPATFileUpload extends Component<MyPATFileUploadProps, MyPATFileUploadState> {
  upload: any = null;
  textarea: any = null;
  isOpenUploadDialog: boolean = false;
  inputForPaste: any = null;
  wrapperRef: any = null;

  constructor(props: MyPATFileUploadProps, state: MyPATFileUploadState) {
    super(props);
    // super(props);

    // this.handleChange.bind(this);
    this.state = {
      isUpload: false,
      uploadImage: '/assets/img/mylibrary/upload-image.png',
      isOpenUploadDialog: false,
      completed: 0,
      zoomIcon: false,
      mathPixData: null,
      image: null,
      showZoomIcon: false,
      isCopied: false,
    };
  }

  setFocusToInput = () => {
    // TODO added simple hack now fix it later
    // const d = document.getElementById('inputForPaste');
    // if (d) {
    //     d.focus()
    // }
    // this.setState({})
  };

  readFile = (event: any) => {
    const { videoUploadHandler } = this.props;
    //console.log('file =>',event.target.files);
    //alert('jiii');
    let file: any = null;
    // //On paste
    // if (event.clipboardData && event.clipboardData.files) {
    //     file = event.clipboardData.files[0]
    // }
    // console.log('event.target', event.target);
    //On upload
    if (event.target.files) {
      file = event.target.files[0];
    }
    //On Drop
    if (event.dataTransfer && event.dataTransfer.files) {
      file = event.dataTransfer.files[0];
    }
    this.props.showVideoModal(true);
    videoUploadHandler && videoUploadHandler(file);
  };

  render() {
    const { classes } = this.props;
    const { isUpload, isCopied, uploadImage, isOpenUploadDialog, completed } = this.state;

    return (
      <Grid container justify='center'>
        <div
          ref={(ref) => {
            this.wrapperRef = ref;
          }}
          className={classes.dragDropVideoContainer}
        >
          <Grid
            container
            justify='center'
            onClick={(e) => {
              // TODO better to use ref but some error change it later
              this.setFocusToInput();
            }}
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDrop={(event) => {
              event.preventDefault();
              //   this.props.handleVideoSelect(event)
              this.readFile(event);
            }}
            style={
              !isUpload && document && document.activeElement && document.activeElement.id === 'inputForPaste'
                ? { opacity: 0.5 }
                : {}
            }
          >
            {/* <Button
                      className ={[classes.margin1X, classes.buttonRoundBorder].join(' ')}
                      autoFocus
                      variant="contained"
                      color="primary"
                      onClick={(e) => { this.upload.value = ''; this.upload.click() }}
                  >
                      <PublishSharpIcon />
                      
              </Button> */}

            <div style={{ width: '100%' }}>
              <img
                alt='Cancel video upload'
                src='/assets/svg/learn/videoUploadIcon.svg'
                onClick={(e) => {
                  this.upload.value = '';
                  this.upload.click();
                }}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <Typography className={classes.dragDropVideoText} component='div' variant='body1' align='center'>
              {isUpload ? 'uploading' : 'Drag and drop video files to upload'}
            </Typography>
            <input
              id='myInput'
              onChange={(event) => {
                //       this.props.handleVideoSelect(event)
                //   }} type="file" ref={(ref) => this.upload = ref} style={{ display: 'none' }} />
                //   <input id="inputForPaste" type="text" ref={(ref) => this.inputForPaste = ref} onPaste={(event) => { this.props.handleVideoSelect(event) }} style={{ opacity: 0, width: 0 }} />
                this.readFile(event);
              }}
              type='file'
              ref={(ref) => (this.upload = ref)}
              style={{ display: 'none' }}
            />
            <input
              id='inputForPaste'
              type='text'
              ref={(ref) => (this.inputForPaste = ref)}
              onPaste={(event) => {
                this.readFile(event);
              }}
              style={{ opacity: 0, width: 0 }}
            />
          </Grid>
        </div>
      </Grid>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    openModal: state.showVideoModalReducers.openModal,
  };
}

const mapDispatchToProps = {
  showVideoModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(MyPATFileUpload));
